import { createAction } from '@lingoda/core';

export default createAction<number>('auth/SET_CURRENT_USER');
